<template>
  <div class="options-correct-order">
    <div class="section">
      <QuizOption
        :option="{ title: quizStatusText }"
        :hasCheckbox="false"
        :class="{
          'timeout': isAnswerTimeout,
          'correct': isAnswerCorrect,
          'incorrect': !isAnswerCorrect && !isAnswerTimeout,
          'checked': !isAnswerTimeout,
        }"
      />
    </div>

    <div class="section-title">
      {{ $t('correctAnswerTitle') }}
    </div>

    <div class="correct-order-group">
      <QuizOption
        v-for="(option, index) in slideOptions"
        :key="option.id"
        :index="index + 1"
        :option="option"
        :hasCheckbox="false"
        :indexed="true"
        :class="{
          'massive': isMassiveOptions,
          'border-none': true,
        }"
      />
    </div>
  </div>
</template>

<script>
import QuizOption from './QuizOption.vue'

export default {
  components: {
    QuizOption,
  },
  props: {
    quizAnswer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    slideOptions() {
      return this.quizAnswer
        && this.quizAnswer.Slide
        && this.quizAnswer.Slide.SlideOptions
    },
    isAnswerTimeout() {
      return this.quizAnswer && this.quizAnswer.timeoutAnswer
    },
    isAnswerCorrect() {
      return this.quizAnswer && this.quizAnswer.correct
    },
    isMassiveOptions() {
      return this.slideOptions.length > 9
    },
    quizStatusText() {
      if (this.isAnswerTimeout) return this.$t('not_answer')

      if (this.isAnswerCorrect) return this.$t('your_answer_correct')

      return this.$t('your_answer_incorrect')
    },
  },
}
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}

.correct-order-group {
  border: 1px solid var(--base-30, #EFF1F7);
  border-radius: 4px;
  padding: 8px 0 8px 0;
}
</style>
